import { getSoftList } from "../service/home";

const soft = {
  name: "soft",
  state: {
    currentSoft: {},
    softList: {},
    show: false,
    loading: false
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    setSoftList(state, payload) {
      return {
        ...state,
        softList: payload,
      };
    },
    setCardShow(state, payload) {
      return {
        ...state,
        show: payload
      };
    },
    setCurrentSoft(state, payload) {
      return {
        ...state,
        currentSoft: {
          ...payload,
        }
      };
    },
    setLoading(state, payload) {
      return {
        ...state,
        loading: payload
      };
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async setSoftListAsync() {
      this.setLoading(true);
      const softList = await getSoftList({
        p_num: 1,
        p_size: 200
      });
      this.setSoftList(softList);
      this.setLoading(false);
      return softList;
    },
  }),
};

export default soft;
